import { Component } from '@angular/core';
import { RokezzzPageLoaderService } from '../../services/page-loader.service';

@Component({
    selector: '.rokezzz-page-loader',
    standalone: true,
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss']
})
export class RokezzzPageLoaderComponent {
    public constructor(
        private readonly rokezzzPageLoaderService: RokezzzPageLoaderService
    ) { }

    public getProgress(): string {
        return this.rokezzzPageLoaderService.getProgress() + '%';
    }

    public isActive(): boolean {
        const progress: number = this.rokezzzPageLoaderService.getProgress();

        return progress > 0 && progress < 100;
    }

    public shouldAnimate(): boolean {
        return this.rokezzzPageLoaderService.getShouldAnimate();
    }
}
